import type { SymbolKey } from './types';

export const symbolKey = (symbol: SymbolKey, isForwardMode = false) => {
  const transactionDateSuffix = (symbol.transactionDate && `-${symbol.transactionDate}`) || '';
  return isForwardMode
    ? `${symbol.Code}-${symbol.PeriodType}-${symbol.TimeRef}${transactionDateSuffix}`
    : `${symbol.Code}-${symbol.PeriodType}-${symbol.Period}-${symbol.TimeRef}${transactionDateSuffix}`;
};
